import { IcMultiplePicker } from 'components/shared/IcPicker/IcMultiplePicker';
import { FC, useMemo } from 'react';
import { useIntl } from 'react-intl';
import type { Notifications } from 'state/userPreferences/userPreferences.model';

import { FlexRowGroupWithNoLabel } from './RowGroup';
import { SectionTitle, TabForm } from './TabForm';

interface NotificationsTabProps {
  onClose: () => void;
  onNotificationContactsChanged: (value: Notifications) => void;

  notifications?: Notifications;
}

export const NotificationsTabForm: FC<NotificationsTabProps> = ({
  onClose,
  onNotificationContactsChanged,
  notifications,
}) => {
  const { formatMessage } = useIntl();
  const contactIds = useMemo(() => {
    return notifications?.contactIds ?? [];
  }, [notifications?.contactIds]);

  return (
    <TabForm labelKey="userPreferencesForm.notifications.label" onClose={onClose}>
      <SectionTitle labelKey="userPreferencesForm.notifications.title" />
      <FlexRowGroupWithNoLabel isFirst className="">
        <div className="w-100">
          <IcMultiplePicker
            withLabel={false}
            placeholder={formatMessage({
              id: 'userPreferencesForm.notifications.placeholder',
              defaultMessage: 'Search Contacts',
            })}
            onChange={contacts => {
              onNotificationContactsChanged({ contactIds: contacts.map(c => c.id) });
            }}
            selectedIds={contactIds}
          />
        </div>
      </FlexRowGroupWithNoLabel>
    </TabForm>
  );
};

NotificationsTabForm.displayName = 'NotificationsTabForm';
